<template>
  <button type="button" class="form-code" :disabled="disabled" @click="getCode()">{{codeName}}</button>
</template>

<script>
import HTTP from "@/api/index";
export default {
  name: "Vtime",
  props: {
    required: {},
    rulePhone: {},
    phoneNumber: {}
  },
  data() {
    return {
      disabled: false,
      codeName: "获取验证码"
    };
  },
  methods: {
    getCode() {
      if (!this.required || !this.rulePhone) {
        this.$layer.msg("请输入正确的手机号码");
        return;
      }
      HTTP.hasCustomer({ phoneNumber: this.phoneNumber, type: 2 }).then(res => {
        console.log(res);
        if (res == "OK") {
          var num = 60;
          this.codeName = `重新发送(60s)`;
          this.disabled = true;
          var timer = setInterval(() => {
            num--;
            if (num <= 0) {
              clearInterval(timer);
              this.codeName = `获取验证码`;
              this.disabled = false;
            } else {
              this.codeName = `重新发送(${num}s)`;
              this.disabled = true;
            }
          }, 1000);
          HTTP.getCode({ phoneNumber: this.phoneNumber });
        } else {
          this.$layer.msg(res.desc);
        }
      });
    }
  }
};
</script>
